module.exports = __webpack_public_path__ + "static/media/logo.348e5719.png";